import { Component } from "react";
import React from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";
import {
  Card, CardBody,
  Modal, ModalHeader, ModalBody, ModalFooter,
  CardTitle, Form, Row, FormGroup, Button, Col, Spinner, Input,Table
} from 'reactstrap';
import axios from "axios";
import appConfig from '../../config/config';
import { connect } from "react-redux";
import Banner from "../common/banner";
import {renderCheckbox,renderInputField} from "../common/renderinput"
import {Loading,LoadingDone,Reset,Success,Error} from "../../actions/loading"

const divStyle = {
  backgroundColor: '#fff'
};
const padStyle = {
  paddingTop: '5px', paddingLeft : '0px'
};

const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined

class SendDoc extends Component {
    state = {
        display:true,
        invoice: 0.0
    };
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }
    submit =(values)=>{
      var sendaction = "SendDoc"
      var url = appConfig.apiGateway.updateOrderUrl
      var data = JSON.stringify({
        ...values,
        DocumentIds: this.props.FileName.map( (i) => { return {Id : i.id, 
          Description : i.filedescript,
          Filename: i.filename + '.'  + i.filetype
         }}),
        OrderProductId: this.props.OrderProductId,
        docgroup:'Loan Cabinet',
        doccode:'Apraisal', 
        Action: "SendDoc",
        UserName: this.props.session.session.user.name
    })

          this.props.Loading();
          console.log(this.props.LOS)
          if (this.props.LOS == 'SALESF') {
            sendaction = "GetAppData"
            var rptDocid = this.props.FileName.find( (i) => { return i.filedescript == 'Final Report XML'}) ? 
                      this.props.FileName.find( (i) => { return i.filedescript == 'Final Report XML'}).id : 0 
            var invDocid = this.props.FileName.find( (i) => { return i.filedescript == 'Invoice'}) ?
                      this.props.FileName.find( (i) => { return i.filedescript == 'Invoice'}).id : 0
            var pdfDocid = this.props.FileName.find( (i) => { return i.filedescript == 'Final Report PDF'}) ? 
                      this.props.FileName.find( (i) => { return i.filedescript == 'Final Report PDF'}).id : 0 


            url = appConfig.apiGateway.getAppDataUrl
            data = JSON.stringify({
              ...values,
              DocumentId : rptDocid,
              InvoiceDocumentId : invDocid,
              PDFDocumentId : pdfDocid,
              OrderProductId: this.props.OrderProductId,
              Action: "GetAppData",
              UserName: this.props.session.session.user.name  
          })
          }
          axios.post(
            url,
              data,
              {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                  }
              }
          ).then((response) => {
              console.log(response)
              this.props.LoadingDone()
              if (!(response.hasOwnProperty('data') && response.data.hasOwnProperty('body')))
              {
                  this.props.Error('Unable to send document')
                  return;
              }
              if (response.data.body.status) {
                  
                  this.props.Success(response.data.body.message)
                  this.props.SendFile(false)
                  return;
              }
              else {
                  console.log(response.data.body.message)
                  this.props.Error("Error while sending")
              }
          },
          (error) => {
              this.props.LoadingDone()
              this.props.Error('Unable to send document')
          }
          )
      
  } 
      renderInvoice() {
        console.log(this.props.LOS)
        if (this.props.LOS == 'MLINK') {
          return(
            <></>
          );
        }
        else if (this.props.LOS == 'SALESF') {
          return(
            <Field
                name="Amount"
                component={renderInputField}
                label="Repaired Amount"
                isLabel="true"
                />
          );
        }
        else {
          return(
            <Field
                name="Amount"
                component={renderInputField}
                label="Invoice Amount"
                isLabel="true"
                />
          );
        }
      }
      render() {
        const file = this.state.selectedFile
        console.log(this.props)
        return (
          <Modal
          isOpen={this.state.display}
          toggle={this.toggle}
          contentClassName="custom-modal-style"
          >
            <form
                  onSubmit={this.props.handleSubmit(this.submit)}
                  style={{ marginLeft: "0%", marginRight: "5%" }}
                >
          <ModalHeader>Send Document</ModalHeader>
                  <ModalBody>
                   
                   <div className="form-row col-12" style={padStyle}>
                   <Table>

                        <tbody>
                        {this.props.FileName.map( i => { return (
                                                        <tr>
                                                        <td>{i.filename+ '.'  + i.filetype}</td>
                                                        <td>{i.filedescript}</td>
                                                        </tr>)
                                                        })}
                        </tbody>
                  </Table>
                        <div className="col-6" style={divStyle}>

                            {this.renderInvoice()}
                        </div>
                    </div>
                   </ModalBody>
                  <ModalFooter>   
                    <Button  type="submit" color="primary">
                      {this.props.loading.loading && <Spinner />}
                      {!this.props.loading.loading && <span>Send</span>}
                    </Button>
                    <Button
                      color="secondary"  onClick={() => this.props.SendFile(false)}>
                      Cancel
                    </Button>
                  </ModalFooter>
                  </form>
                  </Modal>
        );
        }
      
    }    

    const validate = (formValues) => {
      const errors = {};
      if (!formValues.Amount  ) {
          errors.Amount = "Please enter Invoice Amount ";
      }
      if (isNaN(formValues.Amount)  ) {
          errors.Amount = "Please enter amount in correct format ";
      }

      return errors;
  }

    var sendDoc =  reduxForm({
        form: "sendfile",
        validate
      })(SendDoc);
      sendDoc = connect(
        state => ({
            session: state.session,
            loading : state.loading
        }),
        {LoadingDone,Loading,Success,Error,Reset}

    )(sendDoc);
    
    export default sendDoc;